/**
 * Best of Northern Utah 2026 — Winner badge.
 *
 * License usage requirement: the caption "VOTED BEST BUSINESS CONSULTING" must always
 * appear under the badge whenever displayed. This component encapsulates both so the
 * caption can never be accidentally omitted at any call site.
 */
const BADGE_URL = "https://customer-assets.emergentagent.com/job_scaled-up-logan/artifacts/a9vt1148_badge_gold_TJsbJj.png";

const SIZES = {
  xs: { cls: "", w: 56 },
  sm: { cls: "", w: 80 },
  md: { cls: "", w: 112 },
  lg: { cls: "", w: 160 },
  xl: { cls: "", w: 180 },
};

export default function AwardBadge({
  size = "sm",
  align = "left",          // "left" | "center"
  caption = "VOTED BEST BUSINESS CONSULTING",
  tone = "ink",            // "ink" (default, dark text on light bg) | "cream" (light text on dark bg)
  className = "",
}) {
  const sz = SIZES[size] || SIZES.sm;
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  const captionColor = tone === "cream" ? "text-cvc-cream/85" : "text-cvc-ink-soft";
  return (
    <figure
      data-testid="award-badge"
      className={`inline-flex flex-col ${alignCls} ${className}`}
      style={{ width: sz.w }}
    >
      <img
        src={BADGE_URL}
        alt="Best of Northern Utah 2026 — Winner"
        className="h-auto select-none"
        style={{ width: sz.w }}
        loading="lazy"
        draggable={false}
      />
      <figcaption
        data-testid="award-badge-caption"
        className={`font-body text-[9px] sm:text-[10px] tracking-[0.2em] uppercase mt-1.5 ${captionColor}`}
      >
        {caption}
      </figcaption>
    </figure>
  );
}
